import { LinkedRegistry, RegistryCode, RegistryLinkStatus } from "../types/generated/graphql";

export const getDefaultActiveRegistry = (linkedRegistries?: LinkedRegistry[]) => {
  if (!linkedRegistries || linkedRegistries.length === 0) return null;
  if (linkedRegistries.length === 1) return linkedRegistries[0];

  const mretsReg = linkedRegistries.find((registry) => registry.registryCode === RegistryCode.Mrets);
  if (mretsReg?.status === RegistryLinkStatus.Registered) return mretsReg;

  const registeredRegistry = linkedRegistries.find((registry) => registry.status === RegistryLinkStatus.Registered);
  if (registeredRegistry) return registeredRegistry;

  return linkedRegistries[0];
};
